import { RefillAreas } from "../types/departments";

export const orderedRefillAreas: RefillAreas = [
  { area: "01" },
  { area: "02" },
  { area: "03" },
  { area: "04" },
  { area: "05" },
  { area: "06" },
  { area: "07" },
  { area: "08" },
  { area: "09" },
  { area: "10" },
  { area: "11" },
  { area: "12" },
  { area: "13" },
  { area: "14" },
  { area: "15" },
  { area: "16" },
  { area: "17" },
  { area: "18" },
  { area: "20" },
  { area: "50" },
  { area: "70" },
  { area: "SOW" },
  { area: "MOW" },
  { area: "CL" },
  { area: "AA" },
  { area: "AS" },
  { area: "ST" },
  { area: "WH" },
  { area: "SSFA" },
  { area: "OT" },
];
